import { Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Home from "./page/home";
import SignIn from "./components/account/signin/signin";
import SignUp from "./components/account/signup/signup";
import Dashboard from "./dashboard/dashboard";
import SystemPrompt from "./dashboard/SystemPrompt";
import AllResponses from "./dashboard/AllResponses";
import User from "./dashboard/User";
import Contact from "./dashboard/Contact";
import About from "./dashboard/About";
import Privacy from "./dashboard/Privacy";
import TermsAndConditions from "./dashboard/TermsAndCondition";
import PrivateRoute from "./ProtectedRoutes";
import PrivacyGeneral from "./dashboard/PrivacyGeneral";
import TermsAndConditionsGeneral from "./dashboard/TermsGeneral";

function App() {
  return (
    <div className="App">
      <ToastContainer />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/privacy-policy-general" element={<PrivacyGeneral />} />
        <Route path="/terms-and-conditions-general" element={<TermsAndConditionsGeneral />} />

        {/* Private Routes */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/systemprompt"
          element={
            <PrivateRoute>
              <SystemPrompt />
            </PrivateRoute>
          }
        />
        <Route
          path="/allresp"
          element={
            <PrivateRoute>
              <AllResponses />
            </PrivateRoute>
          }
        />
        <Route
          path="/users"
          element={
            <PrivateRoute>
              <User />
            </PrivateRoute>
          }
        />
        <Route
          path="/contact"
          element={
            <PrivateRoute>
              <Contact />
            </PrivateRoute>
          }
        />
        <Route
          path="/about-us"
          element={
            <PrivateRoute>
              <About />
            </PrivateRoute>
          }
        />
        <Route
          path="/privacy-policy"
          element={
            <PrivateRoute>
              <Privacy />
            </PrivateRoute>
          }
        />
         <Route
          path="/terms-and-conditions"
          element={
            <PrivateRoute>
              <TermsAndConditions/>
            </PrivateRoute>
          }
        />
          
      </Routes>
    </div>
  );
}

export default App;
